import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { IApplicationWindow } from 'src/app/shared/models/application-window.model';
import { Cacheable } from 'ts-cacheable';
import { ApplicationWindowRepository } from '../repositories/application-window.repository';
import { PopupHttpErrors } from "../decorators/http-error/popup-http-errors.decorator";

@Injectable({
    providedIn: 'root'
})
export class ApplicationWindowService {

    constructor(private applicationWindowRepo: ApplicationWindowRepository) { }

    @Cacheable()
    @PopupHttpErrors()
    public getActiveApplicationWindows(applicationType?: string): Observable<Array<IApplicationWindow>> {
        return this.applicationWindowRepo.getActiveApplicationWindows(applicationType);
    }

    @Cacheable()
    @PopupHttpErrors()
    public getApplicationWindowByAcyrCode(acyrCode: string): Observable<Array<IApplicationWindow>> {
      return this.applicationWindowRepo.getApplicationWindowByAcyrCode(acyrCode);
    }

    @Cacheable()
    @PopupHttpErrors()
    public getApplicationWindowByTypeAndAcyrCode(type: string, acyrCode: string): Observable<IApplicationWindow> {
      return this.applicationWindowRepo.getApplicationWindowByTypeAndAcyrCode(type, acyrCode);
    }

    @PopupHttpErrors()
    public updateApplicationWindows(acyrCode: string, applicationWindows: Array<IApplicationWindow>): Observable<Array<IApplicationWindow>> {
      return this.applicationWindowRepo.updateApplicationWindows(acyrCode, applicationWindows);
    }

    @PopupHttpErrors()
    public createApplicationWindows(acyrCode: string, applicationWindows: Array<IApplicationWindow>): Observable<Array<IApplicationWindow>> {
      return this.applicationWindowRepo.createApplicationWindows(acyrCode, applicationWindows);
    }

}